module.exports = __webpack_public_path__ + "fonts/MoskauGrotesk-Light.7ec354a0.eot";